import React, { useCallback } from "react";
import { graphql, useQueryLoader } from "react-relay";
import { ServerSearchListbox } from "@olivahealth/oli-ui";
import { mapUsersToDropdown } from "@olivahealth/utils/helpers/user";

import { debounce } from "lodash";
import { UserSelectorQuery as UserSelectorQueryType } from "./__generated__/UserSelectorQuery.graphql";

const UserSelectorQuery = graphql`
  query UserSelectorQuery($search: String) {
    users(first: 20, search: $search) {
      nodes {
        id
        name
        surname
        email
        status
        role
      }
    }
  }
`;

interface Props {
  onUserSelected: (userId: string) => void;
  placeholder?: string;
}

export default function UserSelector({
  onUserSelected,
  placeholder,
}: Props): JSX.Element {
  const [usersQueryReference, loadUsersQuery] =
    useQueryLoader<UserSelectorQueryType>(UserSelectorQuery);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedLoadUsersQuery = useCallback(debounce(loadUsersQuery, 500), [
    loadUsersQuery,
  ]);
  return (
    <ServerSearchListbox
      query={UserSelectorQuery}
      queryReference={usersQueryReference}
      transformDataToOptions={(data) => {
        const typedData = data as UserSelectorQueryType["response"];
        return mapUsersToDropdown(typedData?.users?.nodes);
      }}
      onSearchChange={(inputText) => {
        if (!inputText) {
          return;
        }
        debouncedLoadUsersQuery({
          search: inputText,
        });
      }}
      setSelected={(option) => {
        if (!option?.value) return;
        onUserSelected(option.value);
      }}
      placeholder={placeholder ?? "Search by id, name, email"}
    />
  );
}
